import { ModeloEventoEstatisticas } from "@/store/estatisticas"
import { PeriodoDeExibicao } from "@/types/gerais"

export type DiaDoAno = string
export type IndiceDaSemanaNoAno = number

export type AcumuladoresPorDia = {
  [key in DiaDoAno]: {
    dataReferencia: Date
    acumuloDeMinutosPlanejado: number
    acumuloDeMinutosRealizado: number
  }
}

export type AcumuladoresPorSemana = {
  [key in IndiceDaSemanaNoAno]: {
    inicioDaSemana: Date
    fimDaSemana: Date
    acumuloDeMinutosPlanejado: number
    acumuloDeMinutosRealizado: number
  }
}

export interface ModeloAtividadeGraficoDiario {
  duracaoEmMinutos: number
  dataInicial: Date
  status: "planejada" | "realizada"
}

export interface ModeloAtividadeGraficoSemanal {
  duracaoEmMinutos: number
  dataInicial: Date
  dataFinal: Date
  status: "planejada" | "realizada"
}

export interface IAcumuladorPorPeriodo<AcumuladorPorPeriodo, ModeloAtividade> {
  atividades: ModeloAtividade[]
  listaDeDatasDoPeriodo: Date[]
  acumuladores: AcumuladorPorPeriodo
  inicializarListaDeDatasDoPeriodo(periodoDeExibicao: PeriodoDeExibicao): void
  inicializarAcumuladores(
    periodoDeExibicao?: PeriodoDeExibicao
  ): AcumuladorPorPeriodo
  acumularDados(): AcumuladorPorPeriodo
  montarLegendasGrafico(): string[]
  montarListaDeAtividadesPlanejadas(): number[]
  montarListaDeAtividadesRealizadas(): number[]
}

export abstract class Acumulador<AcumuladorPorPeriodo, ModeloAtividade>
  implements IAcumuladorPorPeriodo<AcumuladorPorPeriodo, ModeloAtividade> {
  atividades: ModeloAtividade[]
  listaDeDatasDoPeriodo: Date[]
  acumuladores: AcumuladorPorPeriodo

  constructor(
    listaDeAtividadesDaAPI: ModeloEventoEstatisticas[],
    periodoDeExibicao: PeriodoDeExibicao
  ) {
    this.atividades = this.formatarDados(listaDeAtividadesDaAPI)
    this.listaDeDatasDoPeriodo =
      this.inicializarListaDeDatasDoPeriodo(periodoDeExibicao)
    this.acumuladores = this.inicializarAcumuladores(periodoDeExibicao)
  }

  abstract formatarDados(
    listaDeAtividadesDaAPI: ModeloEventoEstatisticas[]
  ): ModeloAtividade[]

  abstract inicializarAcumuladores(
    periodoDeExibicao?: PeriodoDeExibicao
  ): AcumuladorPorPeriodo

  abstract montarListaDeAtividadesPlanejadas(): number[]

  abstract montarListaDeAtividadesRealizadas(): number[]

  abstract acumularDados(): AcumuladorPorPeriodo

  abstract montarLegendasGrafico(): string[]

  inicializarListaDeDatasDoPeriodo(periodoDeExibicao: PeriodoDeExibicao) {
    const obterListaDatasPorPeriodo = (): Date[] => {
      const listaDeDatas: Date[] = []
      let dataAtual = periodoDeExibicao.dataInicial
      const totalDeMilissegundosDeUmDia = 86400000

      while (dataAtual <= periodoDeExibicao.dataFinal) {
        listaDeDatas.push(dataAtual)
        dataAtual = new Date(dataAtual.getTime() + totalDeMilissegundosDeUmDia)
      }

      return listaDeDatas
    }

    return obterListaDatasPorPeriodo()
  }
}

type EstruturaDeAcumulo = { [chave: string]: any }
